import React from 'react'
import { Link } from 'react-router-dom'

const Hero = () => {
  return (
    <div className='py-4 pb-8'>
      <div className='w-full flex items-center justify-center'>
        <img src="/images/Build/build__hero.webp" alt="" className="h-[250px] md:h-[350px] object-cover" />
      </div>
        <div className='flex flex-col w-full items-center py-8 gap-4'>
            <h1 className='text-center text-[32px] lg:text-[58px] font-semibold text-[#1b1b1b] leading-[120%] px-4'>Start living the Leafwell Farm lifestyle today.</h1>
            <p className='text-[14px] md:text-[20px] text-[#1b1b1b] w-full lg:w-[80%] text-center px-4'>Leafwell Farm offers a community dedicated to co-living in nature. Our properties are purpose built for a nature oriented live/work environment. Located nearby to major cities and international air travel, our properties are a perfect year-round respite or permanent living space. Our fully furnished suites are designed with you in mind.</p>
            <Link to="/locations/nyc"><button className='bg-[#1b1b1b] text-white rounded-full px-10 md:px-16 py-3.5 md:py-4 text-[14px] md:text-[18px] font-medium mt-4 md:mt-6 lg:mt-8'>Stay</button></Link>
        </div>
    </div>
  )
}

export default Hero